import {Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/_services/data.service';
import { Subscription } from 'rxjs';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-manage-bug',
  templateUrl: './manage-bug.component.html',
  styleUrls: ['./manage-bug.component.scss']
})
export class ManageBugComponent implements OnInit, OnDestroy  {
  bugManageForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  url: string;
  title: any;
  projectId: string;
  testData: any;
  projectData: any = {};
  updateForm: boolean=false;
  scriptDataById: any = [];
  //subscription : Subscription;
  public searchString:string;
  default='default';
  executionMode=["Sequential","Parallel"];
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Manage Bugs',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;

  constructor(
  private formBuilder: UntypedFormBuilder,
  private route: ActivatedRoute,
  private project: ProjectService,
  private dataService : DataService,
  private toastrService:ToastrService,
  private router:Router,
  private urlService: UrlService,
  private memoryService: MemoryService,
  private homeService: HomeService,
  private confirmationDialogService:ConfirmationDialogService) { 
    this.url=environment.baseUrl;
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.getTestData();
       // this.getProjectData();
       setTimeout(() => {
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
          }
        ))
      }, 0)
      }
    )
    this.loadForm();

    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }

  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }

//  getProjectData()
//   {
//     this.subscription =  this.project.getProjectDetails().subscribe((res)=>
//     {
//       this.projectData = res;
//     })
 
//   }

  getTestData(){
    this.dataService.getBugData(this.projectId).subscribe(
      (data) => {
		this.testData = data['bugMetaData'];
    // TreeData = this.projectdata;
		// this.dataSource = this.projectdata;
    });
  }
  
  delRow(id){
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
    .afterClosed().subscribe(res => {
      if (res) {
        this.dataService.deleteBugData(this.projectId, id).subscribe(
          (data)=>{
            this.toastrService.clear();
            this.toastrService.success( 'Bug Metadata Deleted Successfully');
            this.updateForm = false;
            this.getTestData();
            this.ClearForm();
          }
        );
      }
    });
  }

  loadForm(){
    this.bugManageForm = this.formBuilder.group({
      name: ['', Validators.required],
      settingName: ['',Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      // runType:[],
      bugData:[]
    })
  }

   get f() { return this.bugManageForm.controls; }

  onBugData(){
    this.submitted = true;
    if(this. bugManageForm.invalid){
      return;
    }
    var objFormval = this.bugManageForm.value;
    if(this.updateForm === true){
      const ValueForUpdate={
        id:this.scriptDataById[0].id,
        name:objFormval.name,
        settingName:objFormval.settingName,
        // runType:objFormval.runType,
        bugData: objFormval.bugData,
        projectId: this.projectId,
        
        //  parentTestDataId: this.parentTestDataId
      }
      
      this.dataService.updateBugReport(ValueForUpdate).subscribe((data) => {
        if(data) {
          this.testData = data;
          this.toastrService.clear();
          this.toastrService.success('Metadata Update Successfully')
          this.getTestData();
          this.updateForm = false;
          this.ClearForm();
            }
       });
    }
    
    if(this.updateForm == false){
    const ValueForAdd={
      name:objFormval.name,
      settingName:objFormval.settingName,
      // runType:"SEQUENTIAL",
      bugData: objFormval.bugData,
      projectId: this.projectId,
      //  parentTestDataId: this.parentTestDataId
    }
    
    this.dataService.addBugReport(ValueForAdd). subscribe((data) => {
      if(data) {
        this.toastrService.clear();
        this.toastrService.success('Metadata Saved Successfully')
        this.getTestData();
        this.updateForm = false;
        this.ClearForm();
          }  
     });
    }
  }

  updateScript(id){
    this.updateForm = true
    let selectedItem = this.testData.filter((f) => f.id === id);
    this.scriptDataById =  JSON.parse(JSON.stringify(selectedItem));
  }

  ClearForm(){
    this.bugManageForm.reset();
    this.updateForm = false;
  }

  ngOnDestroy() {
  //  this.subscription.unsubscribe();
  }
}